import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { filterPanelBoardsSelector } from '../../../../../aside_panel/filterPanelBoard/store/selectors/filterPanelBoardsSelector';
import { getCurrentEditingFilterIdSelector } from '../../../../../aside_panel/filterPanelBoard/store/selectors/getCurrentEditingFilterIdSelector';
import { filterSelector } from '../../../../../aside_panel/filterPanelBoard/store/selectors/filterSelector';
import { getDefaultOrEditedFilterAction } from '../../../../../aside_panel/filterPanelBoard/helpers/getDefaultOrEditedFilterAction';
import { filterPanelActionSetAction } from '../../../../../aside_panel/filterPanelBoard/store/filterPanelBoards/actions/filterPanelActionSetAction';
import { keyWordSet } from '../../../../../aside_panel/filterPanelBoard/store/filter/actions/keyWordSet';
import { keywordFiltrationEnabledSet } from '../../../../../aside_panel/filterPanelBoard/store/filterPanel/actions/keywordFiltrationEnabledSet';
import { hideSet } from '../../../../../aside_panel/filterPanelBoard/store/filter/actions/hideSet';
import {
    DEFAULT_FILTER_ID,
    FP_KEY_HIDE_FILTER_EMPTY_LIST, FP_KEY_SHOW_FILTER_DONE_CARDS, FP_KEY_SHOW_FILTER_OVERDUE_CARDS,
    MY_WORK_FILTER_BOARD_ID
} from '../../../../../aside_panel/filterPanelBoard/constants';
import { closeFilterInfoPanel } from '../../../../../aside_panel/filterInfoPanel/hocs/effects/closeFilterInfoPanel';
import { panelOpenedSet } from '../../../../../aside_panel/filterPanelBoard/store/filterPanel/actions/panelOpenedSet';
import {
    getDefaultInitialFilter
} from '../../../../../aside_panel/filterPanelBoard/store/filter/helpers/getDefaultInitialFilter';
import _ from 'underscore';
import { EFilterButtonsType } from '../../../store/topBar/types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';

export const searchFilter = (
    key: string,
    boardId: number,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const filterPanel = filterPanelBoardsSelector(state, boardId);
        const filterId = getCurrentEditingFilterIdSelector(filterPanel);
        const filter = filterSelector(state, boardId, filterId);
        const defaultOrEditedFilterAction = getDefaultOrEditedFilterAction(filterId);
        const isTopBarFiltrationEnabled = filterPanelBoardsSelector(state, MY_WORK_FILTER_BOARD_ID).isTopBarFiltrationEnabled
        if (!key) key = null;
        if (filter.searchedKeyWord !== key) {
            if (!key) {
                let isKeywordFiltrationEnabled = false;
                const { permissionId }= getAuthUser(state);
                if (filter.assignees.length === 1 && filter.assignees[0] === permissionId) {
                    isKeywordFiltrationEnabled = true;
                } else if (filter.show.length) {
                    if (filter.show.includes(FP_KEY_SHOW_FILTER_DONE_CARDS)) {
                        isKeywordFiltrationEnabled = true;
                    } else if (filter.show.includes(FP_KEY_SHOW_FILTER_OVERDUE_CARDS)) {
                        isKeywordFiltrationEnabled = true;
                    }
                }
                dispatch(filterPanelActionSetAction(boardId, keywordFiltrationEnabledSet(isKeywordFiltrationEnabled)));
                dispatch(filterPanelActionSetAction(boardId, defaultOrEditedFilterAction(hideSet([]))));
                const isDefaultNotChangedFilter = filter.id === DEFAULT_FILTER_ID && _.isEqual({ ...filter, searchedKeyWord: key }, getDefaultInitialFilter());
                if (!filterPanel.isEnabled && isTopBarFiltrationEnabled || isDefaultNotChangedFilter) {
                    dispatch(closeFilterInfoPanel(boardId));
                }
            } else {
                dispatch(filterPanelActionSetAction(boardId, panelOpenedSet(true)));
                dispatch(filterPanelActionSetAction(boardId, keywordFiltrationEnabledSet(true)));
                dispatch(filterPanelActionSetAction(boardId, defaultOrEditedFilterAction(hideSet([FP_KEY_HIDE_FILTER_EMPTY_LIST]))));
            }
            dispatch(filterPanelActionSetAction(boardId, defaultOrEditedFilterAction(keyWordSet(key))));
        }
    };
    return action;
};
